<template>
  <div>
        <img
            @click="download()"
            :src="fileUrl(product.icon)"
            :alt="product.name"
            :width="imageSize"
            :height="imageSize"
            itemprop="logo"
            :style="`min-width: ${imageSize}px`"
            style="cursor: pointer"
          />
    <!--<b-button size="lg" variant="primary" itemprop="contentUrl" @click="download()">-->
      <!--{{ downloadButtonText }}-->
    <!--</b-button>-->
    <!--<a href="#" target="_blank" class="d-none" ref="clickerButton"/>-->
    <!--<b-button v-if="globalResources.portalType === portalType.Music && isUserAuthenticated && !playMusic" variant="outline-success mt-2" @click="play()">-->
      <!--{{ $t('product.listenToMusic') }}-->
      <!--<img src="https://image.flaticon.com/icons/svg/1666/1666718.svg" height="30">-->
    <!--</b-button>-->

    <!--<audio v-if="isFileUrlFetched && globalResources.portalType === portalType.Music && playMusic" controls class="w-100 mt-3">-->
      <!--<source :src="fetchedFileUrl" type="audio/mpeg">-->
      <!--{{ $t('product.audioBrowserSupport') }}-->
    <!--</audio>-->

    <iframe id="download_iframe" style="display:none;" />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapActions } from 'vuex'
  import enums from '@/utilities/enums.js'

  export default Vue.extend({
    name: 'GameImageDownload',
    mixins: [enums],
    props: {
      product: {
        type: Object,
        default: () => { }
      }
    },
    data() {
      return {
        isFileUrlFetched: false,
        fetchedFileUrl: '',
        playMusic: false,
        productRedirectUrl:""
      }
    },
    computed: {
      ...mapGetters({
        fileUrl: 'cdn/fileUrl',
        tenantInfo: 'tenantConfig/tenantInfo',
        tenantDesignInfo: 'tenantDesign/config',
        isUserAuthenticated: 'auth/isUserAuthenticated',
        designConfig: 'tenantDesign/config',
        userSubscriptions: 'subscription/userSubscriptions'
      }),
      size() {
        let size = this.product.size
        if (size < 1024) {
          return size + this.$t('common.byte')
        } else if (size < 1024 * 1024) {
          return Math.round((size / 1024) * 1000) / 1000 + this.$t('common.kb')
        } else if (size < 1024 * 1024 * 1024) {
          return (
            Math.round((size / (1024 * 1024)) * 1000) / 1000 +
            this.$t('common.mb')
          )
        } else if (size < 1024 * 1024 * 1024 * 1024) {
          return (
            Math.round((size / (1024 * 1024 * 1024)) * 1000) / 1000 +
            this.$t('common.gb')
          )
        } else {
          return ''
        }
      },
      imageSize () {
        return 100
      },
      downloadButtonText() {
        switch (this.product.type) {
          case 'HtmlGame':
            return this.$t('product.play', { product: this.globalResources.productTranslation.Single })
          case 'AndroidGame':
            return this.$t('product.download')
          case 'AudioBook':
            return this.$t('product.download')
          default:
            return ''
        }
      }
    },
    methods: {
      ...mapActions({
        getProductUrl: 'productCatalog/getProductUrl',
        getDownloadToken: 'productCatalog/getDownloadToken',
        showLogin: 'navigation/showLogin',
        loadUserSubscriptionStatus: 'subscription/getUserState'
      }),
      fetchFileUrl(downloadAfterFetch) {
        this.getProductUrl(this.product.id).then(result => {
          let productUrl = result.body.result
          let payload = {
            url: productUrl,
            productId: this.product.id,
            tenantId: this.tenantInfo.id
          }

          switch (this.product.type) {
            case 'HtmlGame':
              this.productRedirectUrl = productUrl
              this.$refs.clickerButton.setAttribute('href', this.productRedirectUrl)
              this.$refs.clickerButton.click()
              break
            case 'AudioBook':
            case 'AndroidGame':
              let payload = {
                url: productUrl,
                productId: this.product.id,
                tenantId: this.tenantInfo.id
              }
              this.getDownloadToken(payload).then((response) => {
                let downloadUrl = this.tenantDesignInfo.general.cdn2Address + '/cdn/download/ticket/' + response.body.result
                this.fetchedFileUrl = downloadUrl
                this.isFileUrlFetched = true

                if (downloadAfterFetch) {
                  document.getElementById('download_iframe').src = this.fetchedFileUrl
                }
              })
              break
          }
        })
      },
      download() {
        let loginType = this.designConfig.userManagement.loginType
        if (!this.isUserAuthenticated) {
          if (loginType === 'vas') {
            this.showLogin()
          } else if (loginType === 'organic') {
            if (this.product.tenantProduct.rightType === 'Free') {
              this.$ga.event('Game', 'AndroidDLButton', this.product.id)
              this.fetchFileUrl(true)
            }
            else {
              window.localStorage.setItem('lastProductPageId', this.product.id);
              this.$router.push({ name: 'login' })
            }
          }
        } else {
          if (loginType === 'organic') {
            if (this.product.tenantProduct.rightType === 'Premium') {
              var subscriptions = this.userSubscriptions.filter(function (elem) {
                if (elem.planType !== 'Free' && elem.state === 'Subscribe') { return elem }
              })
              if (subscriptions.length > 0) {
                this.$ga.event('Game', 'AndroidDLButton', this.product.id)
                this.fetchFileUrl(true)
              }
              else {
                this.$bvToast.toast(this.$t('product.downloadWarning'), {
                  title: this.$t('UserProfile.Subscription.BuySubscriptionFactor.BuySubscription'),
                  autoHideDelay: 40000,
                  appendToast: true,
                  variant: 'danger',
                  solid: true
                })
                setTimeout(() => {
                  this.$ga.event('Registration', 'RedirectToProfileFromGamePage', this.product.id)
                  this.$router.push({ name: 'profile' })
                }, 3000)
              }
            } else {
              this.$ga.event('Game', 'AndroidDLButton', this.product.id)
              this.fetchFileUrl(true)
            }
          }
          if (loginType === 'vas') {
            this.fetchFileUrl(true)
          }
        }
      },
      play() {
        this.playMusic = true
        this.$ga.event('Game', 'HTML5PlayButton', this.product.id)
        if (!this.isFileUrlFetched) {
          this.fetchFileUrl(false)
        }
      }
    },
    mounted() {
        this.loadUserSubscriptionStatus();
     },
    created() {
       this.loadUserSubscriptionStatus();
    },
  })
</script>
